module.exports = __webpack_public_path__ + "img/failed.e07f0e5c.svg";